import React, { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import TextButton from '../../../Buttons/TextButton';
import BasicUserName from '../../../User/BasicUserName';
import { ThemeContext } from '../../../Context/ThemeContext';
import { ThemeOptions } from '../../../publicSession/types';
import s from './Horoscope.scss';
var Horoscope = function (_a) {
    var _b;
    var deviation = _a.deviation;
    var t = useTranslation().t;
    var theme = useContext(ThemeContext);
    if (!((_b = deviation.extended) === null || _b === void 0 ? void 0 : _b.fortune) || !deviation.author) {
        return null;
    }
    return (React.createElement("div", { className: s['root'], "data-hook": "ART_FORTUNE" },
        React.createElement("img", { src: "https://st.deviantart.net/eclipse/global/svg/artfortune.svg", width: 321, height: 115, alt: "" }),
        React.createElement("div", { className: s['title'] },
            React.createElement(Trans, { i18nKey: "aprilFools.fortune.title" },
                React.createElement(BasicUserName, { user: deviation.author }),
                "\u2019s Art Fortune")),
        React.createElement("div", { className: s['body'] }, deviation.extended.fortune.fortuneText),
        React.createElement(TextButton, { size: "medium", variant: theme === ThemeOptions.DARK ? 'approval-green' : 'unbranded', href: deviation.extended.fortune.learnMoreUrl }, t('aprilFools.fortune.button'))));
};
Horoscope.displayName = 'Horoscope';
export default Horoscope;
//# sourceMappingURL=Horoscope.js.map